const allowedLegacyFields = [
	'auction_status',
	'top_offerer_dealership_id',
	'bid_sale_id',
	'status',
	'lowest_counter_date',
	'best_offer_date',
	'version',
	'acceptable_counter_offer_activity',
	'offerer_dealership_id',
	'ae_auction_id',
	'auction_style_end',
];

const removeUnusedFields = (offerData = {}, allowedFields = []) => {
	const objectToReturn = {};
	Object.keys(offerData).forEach((key) => {
		if (allowedFields.includes(key)) {
			objectToReturn[key] = offerData[key];
		}
	});

	if (allowedFields.includes('top_offerer_dealership_id') && offerData.best_offer_offerer_dealership_id) {
		objectToReturn.top_offerer_dealership_id = offerData.best_offer_offerer_dealership_id;
	}
	if (allowedFields.includes('auction_status') && !objectToReturn.auction_status) {
		objectToReturn.auction_status = offerData.bid_sale_auction_status;
	}

	return objectToReturn;
};

export const normalizeLegacyOfferSummaryRow = (offerData = {}) => removeUnusedFields(offerData, allowedLegacyFields);
